<template>
  <div>
    <a ref="lienDownload"></a>
    <v-server-table v-if="cliNum" url="" :columns="columns" :options="options"
                    @loaded="finLoading" @loading="debutLoading" @error="erreur" >
      <div slot="dateCommande" slot-scope="props">
        {{props.row.dateCommandeFormat}}
      </div>
      <div slot="montantHt" slot-scope="props">
        <div class="is-pulled-right">{{props.row.montantHtFormat}}</div>
      </div>
      <div slot="pdf" slot-scope="props">
        <a @click="genererPdf(props.row)">
          <b-icon icon="download" type="is-primary"/>
        </a>
      </div>
      <div slot="cmdEtat" slot-scope="props">
        {{ formatEtat(props.row.cmdEtat) }}
      </div>
      <div slot="cmdCategorie" slot-scope="props">
        {{ formatCategorie(props.row.cmdCategorie) }}
      </div>
    </v-server-table>
  </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import { getCommandesByClient, getCommandesPdf } from '@/api/commandes';
import gestionErreur from '@/services/general/gestionErreur';
import { TEXTS, PER_PAGE_VALUE, RESULTS_PER_PAGE } from '@/configuration/clientTableConf';
import {
  COMMANDE_ETAT,
  COMMANDE_ETAT_AFFIXE2,
  COMMANDE_CATEGORIE,
  COMMANDE_CATEGORIE_AFFIXE2,
  COMMANDE_TYPE,
  COMMANDE_TYPE_AFFIXE2,
} from '@/components/mesOpportunites/configuration/commandeConf';

const User = createNamespacedHelpers('user');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  name: 'index',
  props: ['cliNum'],
  data() {
    return {
      trad: {
        cmdCode: 'Code',
        cmdEtat: 'Etat',
        cmdCategorie: 'Catégorie',
        cmdType: 'Type',
        dateCommande: 'Date commande',
        montantHt: 'Montant HT',
        pdf: 'Télécharger',
      },
      columns: ['cmdCode', 'cmdEtat', 'cmdCategorie', 'cmdType', 'dateCommande', 'montantHt', 'pdf'],
      loadingComponent: null,
    };
  },
  computed: {
    ...User.mapGetters({
      userEmail: 'userEmail',
    }),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
    options() {
      return {
        headings: {
          cmdCode: this.trad.cmdCode,
          cmdEtat: this.trad.cmdEtat,
          cmdCategorie: this.trad.cmdCategorie,
          cmdType: this.trad.cmdType,
          dateCommande: this.trad.dateCommande,
          montantHt: this.trad.montantHt,
          pdf: this.trad.pdf,
        },
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        debounce: 600,
        filterByColumn: true,
        filterable: ['cmdEtat', 'cmdType', 'cmdCategorie', 'cmdCode', 'montantHt'],
        listColumns: {
          cmdEtat: this.isAffixe2 ? COMMANDE_ETAT_AFFIXE2 : COMMANDE_ETAT,
          cmdCategorie: this.isAffixe2 ? COMMANDE_CATEGORIE_AFFIXE2 : COMMANDE_CATEGORIE,
          cmdType: this.isAffixe2 ? COMMANDE_TYPE_AFFIXE2 : COMMANDE_TYPE,
        },
        requestFunction: ((data) => {
          data.query = {
            ...data.query,
            tiersId: this.cliNum,
          };
          return getCommandesByClient(this.userEmail, data, this.cliNum);
        }),
        responseAdapter: ((result) => {
          result.data.forEach(cmd => {
            cmd.dateCommandeFormat = moment(cmd.dateCommande).format('DD/MM/YYYY');
            cmd.montantHtFormat = parseFloat(cmd.montantHt).toLocaleString(undefined,
              { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          });
          return {
            data: result.data,
            count: result.headers['x-total-count'],
          };
        }),
      };
    },
  },
  methods: {
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open({ container: null });
    },
    finLoading() {
      this.loadingComponent.close();
    },
    erreur(e) {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      gestionErreur('Erreur interne', e);
    },
    formatEtat(etat) {
      return COMMANDE_ETAT[etat].text;
    },
    formatCategorie(categorie) {
      return COMMANDE_CATEGORIE[categorie].text;
    },
    genererPdf(data) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      getCommandesPdf(data.cmdNum, data.cmdCode, data.socCode).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Edition_' + data.cmdCode + '.pdf';
        link.click();
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur(`Erreur lors de la génération du PDF de la commande n°${data.cmdNum}`, e);
        loadingComponent.close();
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/clientProspect/ficheClient/historique/index.vue